import script from "./TranscriptAssets.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptAssets.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptAssets.vue?vue&type=style&index=0&id=47666725&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47666725"]])

export default __exports__